import { render, staticRenderFns } from "./BidsListFilter.vue?vue&type=template&id=2c6f6b01&scoped=true&"
import script from "./BidsListFilter.vue?vue&type=script&lang=js&"
export * from "./BidsListFilter.vue?vue&type=script&lang=js&"
import style0 from "./BidsListFilter.vue?vue&type=style&index=0&id=2c6f6b01&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f6b01",
  null
  
)

export default component.exports